var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHospital = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 12.8,
    viewBox: "0 0 16 12.8",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "hospital",
    d: "M4,1.6A1.6,1.6,0,0,1,5.6,0h4.8A1.6,1.6,0,0,1,12,1.6v.8h2.4A1.6,1.6,0,0,1,16,4v7.2a1.6,1.6,0,0,1-1.6,1.6H1.6A1.6,1.6,0,0,1,0,11.2V4A1.6,1.6,0,0,1,1.6,2.4H4Zm8,6.8V12h2.4a.8.8,0,0,0,.8-.8V8h-2a.4.4,0,1,1,0-.8h2V5.6h-2a.4.4,0,1,1,0-.8h2V4a.8.8,0,0,0-.8-.8H12ZM4,3.2H1.6A.8.8,0,0,0,.8,4v.8h2a.4.4,0,0,1,0,.8H.8V7.2h2a.4.4,0,0,1,0,.8H.8v3.2a.8.8,0,0,0,.8.8H4Zm7.2,5.2V1.6a.8.8,0,0,0-.8-.8H5.6a.8.8,0,0,0-.8.8V12H6.4V10.4a1.6,1.6,0,0,1,3.2,0V12h1.6Zm-2.4,2a.8.8,0,0,0-1.6,0V12H8.8ZM7.6,1.6h.8a.6.6,0,0,1,.6.6v.4h.4a.6.6,0,0,1,.6.6V4a.6.6,0,0,1-.6.6H9V5a.6.6,0,0,1-.6.6H7.6A.6.6,0,0,1,7,5V4.6H6.6A.6.6,0,0,1,6,4V3.2a.6.6,0,0,1,.6-.6H7V2.2A.6.6,0,0,1,7.6,1.6ZM7.8,3a.4.4,0,0,1-.4.4H6.8v.4h.6a.4.4,0,0,1,.4.4v.6h.4V4.2a.4.4,0,0,1,.4-.4h.6V3.4H8.6A.4.4,0,0,1,8.2,3V2.4H7.8Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHospital);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/hospital.23454e904a2a6058204ebf0c5d2af46a.svg";